import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { JNative } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { Button } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Button";
import { IPickerDialog, PickerDialog, PickerDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PickerDialog";

export type PickerDialogCasePropertyValues =
    PickerDialogPropertyValues
    & {
    };

export type PickerDialogCaseProperties = {
    [name in keyof PickerDialogCasePropertyValues]: Property<PickerDialogCasePropertyValues[name]>
};

export interface IPickerDialogCase extends IPickerDialog, PickerDialogCaseProperties
{
}

export class PickerDialogCase extends PickerDialog implements IPickerDialogCase
{
    // #region Static

    // #region Overrides

    // #region Methods

    public static override createPropertyDefaults(): PartialNullable<PickerDialogCasePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                columns: [
                    { dataSourceProperty: "caseReference", name: "Reference", sortable: true },
                    { dataSourceProperty: "cypSurname", name: "CYP Surname", sortable: true },
                    {
                        addCellContents: ($$cell: JNative, column: any, dataSource: any, value: any) =>
                        {
                            new Button({ cssClass: "rad-action-select", inline: true, text: "Select", elementTitle: value ? `Select ${value}` : null })
                                .$$element.get()?.appendTo($$cell);
                        },
                        cssClass: "rad-column-item-select"
                    },
                ],
                dataServiceId: "B0B76DF9-F754-4C53-875D-CF55627E6051",
                dataServiceOperation: "SearchCases",
                scrollable: false,
                title: "Search Cases",
                topN: 100,
            }
        };
    }

    // #endregion

    // #endregion

    // #endregion
}
